export default __webpack_public_path__ + "static/joanna2-e1eca10ea3196fbebffcd369c67d54fa.jpg";